module.exports = __webpack_public_path__ + "static/img/pc_code.1d831e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/pc_code.png
// module id = 0fNZ
// module chunks = 1